import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCeuta = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_810)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 0C8.68626 0 5.68626 1.34316 3.51469 3.51469L12 12V0Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 12C0 15.3137 1.34316 18.3137 3.51469 20.4853L12 12H0Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C15.3137 24 18.3137 22.6568 20.4853 20.4853L12 12V24Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M24 12C24 8.68627 22.6568 5.68627 20.4853 3.51469L12 12H24Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.82611 8.34783L12 8.86969L16.1739 8.34783V5.84348L14.5043 6.67828L12 4.17389L9.49566 6.67828L7.82611 5.84348V8.34783Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 18.2609C9.69849 18.2609 7.82611 16.3884 7.82611 14.087V9.91326L9.39131 8.34792H14.6087L16.1739 9.91326V14.087C16.1739 16.3884 14.3015 18.2609 12 18.2609Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 16.6957C10.5615 16.6957 9.39131 15.5254 9.39131 14.087V9.91313H14.6087V14.0869C14.6087 15.5254 13.4385 16.6957 12 16.6957Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.82611 8.34782H9.39131V9.91303H7.82611V8.34782Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.6087 8.34782H16.1739V9.91303H14.6087V8.34782Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.6087 11.7391H16.1739V13.3043H14.6087V11.7391Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.82611 11.7391H9.39131V13.3043H7.82611V11.7391Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 16.6957C11.7274 16.6957 11.4645 16.6535 11.2174 16.5756V18.1862C11.4711 18.2346 11.7324 18.2609 12 18.2609C12.2676 18.2609 12.5289 18.2346 12.7826 18.1862V16.5756C12.5355 16.6534 12.2726 16.6957 12 16.6957Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.42619 14.5104L8.17706 15.7596C8.39363 16.2526 8.70263 16.696 9.08241 17.0677L10.1887 15.9615C9.79388 15.5801 9.51886 15.0757 9.42619 14.5104Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.8229 15.7597L14.5738 14.5105C14.4811 15.0757 14.2061 15.5801 13.8114 15.9616L14.9176 17.0679C15.2973 16.6961 15.6064 16.2527 15.8229 15.7597Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.4783 10.7827V11.6522C11.4783 11.9403 11.7119 12.1739 12 12.1739C12.2881 12.1739 12.5217 11.9403 12.5217 11.6522V10.7827H11.4783Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.4783 14.2609V15.1305C11.4783 15.4185 11.7119 15.6522 12 15.6522C12.2881 15.6522 12.5217 15.4185 12.5217 15.1305V14.2609H11.4783Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.0435 12.5217V13.3913C13.0435 13.6794 13.2771 13.9131 13.5652 13.9131C13.8533 13.9131 14.0869 13.6794 14.0869 13.3913V12.5217H13.0435Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.4783 12.5217V13.3913C11.4783 13.6794 11.7119 13.9131 12 13.9131C12.2881 13.9131 12.5217 13.6794 12.5217 13.3913V12.5217H11.4783Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.91303 12.5217V13.3913C9.91303 13.6794 10.1466 13.9131 10.4348 13.9131C10.7229 13.9131 10.9565 13.6794 10.9565 13.3913V12.5217H9.91303Z",
				fill: "#0052B4"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_810",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgCeuta;
